import { render } from "./VideoBackgroundEditor.vue?vue&type=template&id=eac38da2&scoped=true"
import script from "./VideoBackgroundEditor.vue?vue&type=script&lang=js"
export * from "./VideoBackgroundEditor.vue?vue&type=script&lang=js"

import "./VideoBackgroundEditor.vue?vue&type=style&index=0&id=eac38da2&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eac38da2"]])

export default __exports__